module.exports = __webpack_public_path__ + "img/civil_engineering_stats.2c746794.png";